import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="home" className="min-h-screen flex items-center pt-20 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in">
            <div>
              <div className="h-1 w-20 bg-yellow-500 mb-6"></div>
              <p className="text-yellow-500 uppercase tracking-widest text-sm font-semibold mb-6">
                LEGAL EXCELLENCE
              </p>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Trusted Legal Solutions for Your Business
            </h1>
            
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed">
              Expert guidance in incorporation, international trade, and intellectual property protection. Building your legal foundation with precision and care.
            </p>
            
            <Button
              onClick={() => navigate('/request')}
              className="bg-yellow-500 hover:bg-yellow-600 text-slate-900 font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-yellow-500/20 group"
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
          </div>

          {/* Right Image */}
          <div className="relative animate-fade-in-delayed">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://images.pexels.com/photos/6077797/pexels-photo-6077797.jpeg"
                alt="Legal Services"
                className="w-full h-[600px] object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent"></div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 -top-4 -right-4 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl"></div>
            <div className="absolute -z-10 -bottom-4 -left-4 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;